import { render, staticRenderFns } from "./RequestServiceApproval.vue?vue&type=template&id=2e60bd48&scoped=true"
import script from "./RequestServiceApproval.vue?vue&type=script&lang=js"
export * from "./RequestServiceApproval.vue?vue&type=script&lang=js"
import style0 from "./RequestServiceApproval.vue?vue&type=style&index=0&id=2e60bd48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e60bd48",
  null
  
)

export default component.exports